export const list = [
  { name: "Produkt", path: "/" },
  { name: "Działanie", path: "/dzialanie" },
  { name: "O projekcie", path: '/projekt' },
  //{ name: "Realizacje", path: "/realizacje" },
  { name: "Kontakt", path: "/kontakt" },
]
